// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1827":"7fe95281","8570":"39438780"}[chunkId] + ".chunk.css";
};